import React from 'react';
import Container from '../Layout/Container';
import { Box } from '../Layout';
import Image from '../Image';
import team from '../images/team.jpg';
import blindPlayer from '../images/blind-player.jpg';
import nationalSquad from '../images/national-squad.jpg';
import abf4allBall from '../images/abf4all-ball.jpg';
import newsArticleHandbookExample from '../images/news-article-handbook-example.png';
import parafivesLaunch from '../images/parafivesLaunch.png';

const News = () => (
  <Container>
    <Box>
      <h1>News</h1>
      <Box pb={14}>
        <p>May, 2021</p>
        <h2>National Blind Football Series launches at The Hangar</h2>

        <p>
          Sunday 16 May 2021 marked the next step in the development of blind football by Australian Blind Football with the launch of the National Blind Football Series at
          The Hangar in Melbourne.
        </p>
        <Image src={parafivesLaunch} width="600px" />
        <p>
          “It was fantastic have the national squad back together after over 18 months and to see so many people come
          along to the launch and experience blind football, some for the first time” said Australian Blind Football
          National Manager Dave Connolly. “We want to provide the best platform for our blind footballers to achieve
          their goals, both individually and as a team, and we believe the National Blind Football Series will do that.”
        </p>
        <p>
          The National Blind Football Series is all about providing blind footballers with the opportunity to play
          competitive matches more often. Due to COVID-19 restrictions in 2021 matchdays have been delayed and will take place at national camps in 2022. At the conclusion of the Series the inaugural National Blind Football 
          Champions will be announced.
        </p>
        <p>
          Throughout 2022 South Melbourne FC and Olympic FC will take part in the National Blind Football Series. Over the
          next three years Australian Blind Football aims to have teams representing other ABF4ALL partner clubs, which
          includes Adelaide Comets FC, Perth Soccer Club and a soon to be announced Sydney based club. These
          partnerships not only provide the opportunity for players to represent a local community football club in a
          national competition, players will also form community connections through these clubs back in their home
          states at local training sessions. The National Blind Football Series has been made possible through the
          generous support from the Professional Footballers Australia&#39;s Footballers Trust and Paralympics
          Australia.
        </p>
        <p>
          At the launch event, guests including Matildas squad member Melina Ayres, Western United FC&#39;s Sebastian
          Pasquali and Hakeem Al-Araibi, were given the opportunity to give blind football a try, with instructions and
          demonstrations given by our national squad coaches and footballers. This was followed by an exhibition match
          between South Melbourne FC and Olympic FC.
        </p>
        </Box>
      <Box pb={14}>
        <p>Mar, 2021</p>
        <h2>ABF4ALL to re-ignite blind and partially sighted football across the country</h2>

        <p>
          Australian Blind Football was due to launch into the next stage of development of the sport in 2020, but then
          COVID-19 hit.
        </p>
        <p>
          During this downtime of lengthy lockdowns in 2020 Dave Connolly, National Manager at Australian Blind
          Football, talked to a number of players across the country to find out what they wanted to get out of playing
          blind and partially sighted football. Whilst some aspired to playing internationally and representing their
          country, the overwhelming response was that they wanted to be part of community sport clubs, providing
          community connection and making friends.
        </p>
        <Image src={abf4allBall} width="600px" />
        <p>
          Therefore, Dave set about developing a new program that would provide this connection and opportunities for
          all. The result is ABF4ALL, which follows Football Australia&#39;s direction of &#39;football for all&#39;.
          ABF4ALL aims to increase grassroots participation in football by people who are blind or partially sighted,
          regardless of age, gender or ability.
        </p>
        <p>
          To ensure a strong and sustainable program Dave connected with State Football Federations and researched
          community football clubs that would be a good &#39;fit&#39; so that they could work together to develop and
          grow grassroots participation in football for people who are blind or partially sighted. &#39;I have been
          pleasantly surprised at the enthusiasm of the football community to be involved and take the ABF4ALL
          initiative on as part of what they do.&#39;
        </p>
        <p>
          Having being involved in football since a young age Dave believed that once the football community was aware
          of the sport, they would embrace it. &#39;I was fortunate to be able to attend the 2014 IBSA Blind Football
          World Championships and was blown away by the skills and professionalism of the sport. I also experienced how
          the sport was a worldwide community which was a refreshing change for football. Coaches from different
          countries would be talking to each other outside of games, learning from each other with the goal of making
          the sport the biggest format of para football. I knew that as soon as the football community were exposed to
          blind football and partially sighted futsal they would also be “hooked” and want to get involved,&#39; said
          Dave.
        </p>
        <p>
          The ABF4ALL program will &#39;Kick-off&#39; in March and April 2021 and will be run in partnership with
          community football clubs. Partner clubs for 2021 include South Melbourne Football Club, Perth Soccer Club and
          Adelaide Comets Football Club, (Brisbane) Olympic Football Club and Blind and Vision Impaired Football NSW, a
          standalone organisation to develop opportunities within NSW.
        </p>
        <p>
          Dave continued, &#39;I&#39;m really excited about 2021 and the future of blind and partially sighted football
          in Australia. 2020 was a tough year for everyone and we wanted to utilise this “downtime” in a positive way so
          that we could re-ignite our sport and get more people who are blind or partially sighted playing football and
          connected with their communities. We believe the ABF4ALL program and the partnerships that have been developed
          has achieved this goal.&#39;
        </p>
        <p>
          To support this development work, Dave Connolly has been working with the national coaching team and Blind
          Sports Australia staff to develop a resource for coaches and volunteers. With programs setup across the
          country, and with potential border closures restricting movement interstate to visit in person, a resource is
          an important part of sharing knowledge of the sport and for coaches to feel supported in the program. The
          ABF4ALL Handbook has been created and this will provide invaluable guidance and resources for coaches and
          volunteers. In the coming months an online portal will be &#39;live&#39; which will be an additional resource
          to support coaches, volunteers and national squad members. This portal will include demonstrations of
          activities that can be run at local sessions or at home with family and friends. The ABF4ALL Handbook will be
          released over the coming weeks at the ABF4ALL &#39;Kick-off&#39; sessions.
        </p>
        <p>
          The development work being undertaken by Australian Blind Football would not have been possible without the
          generous support from the AMP Foundation, where Dave is a #tomorrowmaker. Australian Blind Football is very
          grateful for the support of the foundation to assist with developing blind and partially sighted football
          opportunities across Australia.
        </p>
        <Image src={newsArticleHandbookExample} />
      </Box>
      <Box pb={14}>
        <p>Oct, 2020</p>
        <h2>World Blindness Awareness Month</h2>
        <p>
          The month of October marks an important awareness month, World Blindness Awareness Month. During the month of
          October 2020, Australian Blind Football will play their part in raising awareness and knowledge of blindness
          and vision loss in the community through a social media campaign.
        </p>
        <p>Notable days in October are World Sight Day on 8th October and White Cane Safety Day on 15th October. </p>
        <p>
          Alongside raising awareness of blindness and vision loss in the community, Australian Blind Football will be
          promoting local opportunities from across the country for people who are blind or partially sighted of all
          ages, gender and abilities to play football.
        </p>
        <p>
          Blind and partially sighted football is growing across the globe and Australian Blind Football players,
          coaches and volunteers want to shine the light on those with irreversible blindness or vision loss and show
          how people who are blind or partially sighted can continue to lead a full life and enjoy the physical and
          social benefits of participating in sport.
        </p>
        <p>Come Play!</p>
        <Image src={blindPlayer} />
      </Box>

      <p>Nov, 2018</p>
      <h2>Australian Blind Football &ndash; 2018 International Tours report</h2>
      <p>
        In September 2018, our national blind football and vision impaired futsal teams went overseas for their first
        international tours. Below is a report on the international tours of both teams:
      </p>
      <Image src={team} />
      <p>
        <strong>Blind Football </strong>
      </p>
      <p>
        Our national blind football team travelled to Kochi, India from 17 to 22 September. This tour was supported by
        the India Blind Football Federation. The team took part in a two match international friendly series and joint
        training sessions with the players and staff.
      </p>
      <p>
        The first game took place on Wednesday 19 September and even though India won 2-0, the team performed superbly,
        holding the India team at bay in the second half and even had a couple of chances of their own. With this being
        the first ever game for most of the players, it was a great effort.
      </p>
      <p>
        &ldquo;It was an amazing experience. The first Australian Blind Football (B1) team competing at an international
        level has been a few years in the making and it was an emotional time for everyone after the match,&rdquo; said
        Australian Blind Football Coordinator (and goal guide for the games) Dave Connolly.
      </p>
      <p>
        The second game took place on Friday 21 September and following a week of training and games the team put in
        another great effort, with the India team showing their skills and coming away with a 5-0 win. The team were
        just a finger-tip away from scoring their first ever goal with captain for the tournament, Brendan Spencer,
        being denied by a marvellous save from the Indian keeper midway through the first half with Australia only down
        2-0. India&#39;s superior game experience meant they were able to put away chances with Australian keeper Nathan
        Meneses producing a number of fantastic saves. Nathan was named player of the match, awarded for his outstanding
        performance in goals.
      </p>
      <p>
        &ldquo;We learnt so much during this trip, from preparation to recovery, working on game plans and adjusting to
        new conditions &ndash; it was extremely humid in Kochi! As we became more accustomed to the conditions and
        worked hard during the training sessions, we improved as the week went on. I personally learnt a lot from this
        trip and it has given me motivation to train hard to prepare for the next challenge of our first ranking
        tournament in 2019 at the Asian Championships,&rdquo; said Brendan.
      </p>
      <p>
        We must thank the India Blind Football Federation and all of its volunteers and partners for running a fantastic
        series.
      </p>
      <p>
        The team that competed in this first international series was Nathan Meneses (Goalkeeper), Brendan Spencer
        (Captain), Nathan Letts, Andrew Close, Shae Skinner, Igor Negrao (Coach), Dave Connolly (Goal guide) and Simon
        Kaplun (Team Manager and Physio).
      </p>
      <Image src={nationalSquad} />
      <p>
        <strong>Vision Impaired Futsal </strong>
      </p>
      <p>
        Our national vision impaired futsal team travelled to Kuala Lumpur, Malaysia from 23 to 28 September to take
        part in a three-match series with the Malaysian vision impaired futsal team.
      </p>
      <p>
        The team had three games scheduled against Malaysia, all of which turned out to be vastly different. Game one
        saw Australia participate in their first international game and it became a fact-finding mission about the
        opposition and themselves. Malaysia won 7-5.
      </p>
      <p>
        In our second game the team began with a different structure to accommodate skills in different positions and
        levels of sight. The team started confidently, but conceded two early goals before creating some opportunities
        through some solid defensive work from Steffan Nero and Scott Dann turning defence into attack and not only
        drawing level before half-time but going into the break up 4-2. Unfortunately with the humidity and heat the
        team was beginning to struggle and consequently allowed the Malaysian&rsquo;s their opportunity to bring the
        game back to 4-4 all. The team found their poise and vigour again to take the lead in the last couple of
        minutes, taking out an historic win 6-5.
      </p>
      <p>
        The team was ready to put everything on the line for the final and deciding game. Once again the team started
        slowly, conceding two easy goals, and another just before half-time, making the task of a comeback near
        impossible. The second half saw the team create numerous chances with little luck, whilst our defence became
        extremely hard to penetrate with Simon Briffa defying all his ailments from the two previous games to be able to
        throw his body at everything directed at goal. With no team being able to score another goal in the second half
        the game finished with Malaysia winning 3-0.
      </p>
      <p>
        &ldquo;It was an honour to captain this team in our inaugural international competition,&rdquo; said Captain
        Nick Haydardedeoglu.
      </p>
      <p>
        &ldquo;It was a great experience for the team, taking part in their first international tour. The team performed
        well, learnt a lot and we are looking forward to developing this group further and competing in more
        international games in the future,&rdquo; said Coach Michael Roski.
      </p>
      <p>
        Our goal scorers for the tournament were Oscar Stubbs (5), Ethan (2), Steve Obeid (2), Sean Brown (1) and Nick
        Haydardedeoglu (1).
      </p>
      <p>
        The day after the final match saw a joint training session with the Malaysian team and coaching staff, this was
        a great way to wrap up a wonderful trip. Making connections off the field is as important as the results on the
        field. We thank Malaysian Blind Football and all their volunteers for organising the event.
      </p>
      <p>
        The team that competed in this first international series was Simon Briffa (Goalkeeper), Nick Haydardedeoglu
        (Captain), Steve Obeid (Vice-Captain), Steffan Nero, Sean Brown, Johnny Boland, Scott Dann, Ned Brewer-Maiga,
        Ethan Scaturchio, Oscar Stubbs, Dion Kalogiros, Michael Roski, Stephanie Taylor and Igor Negrao (Coaches), Vince
        Scaturchio (Team Manager).
      </p>
    </Box>
  </Container>
);
export default News;



// WEBPACK FOOTER //
// ./src/News/News.js